import $ from 'jquery'

$(document).on('submit', '.bhub-service-product-listing-search', function (e) {
  e.preventDefault()

  let form = $(this)
  let list = form.next('.bhub-service-product-listing')

  $.ajax({
    url: bookingHub.ajaxUrl,
    method: 'POST',
    dataType: 'json',
    data: {
      action: 'bhub/service_product_list/filter',
      form: form.serialize(),
      nonce: form.find('#nonce').val(),
    },
    beforeSend: function () {},
    success: function (response) {
      if (response.success) {
        list.html(response.data.html)
      } else {
        bookingHub.notyf.error(response.data.message)
      }
    },
  })
})
